import { render, staticRenderFns } from "./LuckyBalls.vue?vue&type=template&id=138fa653&"
import script from "./LuckyBalls.vue?vue&type=script&lang=js&"
export * from "./LuckyBalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports